var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.08594C10.6569 3.08594 12 4.42908 12 6.08594C12 7.48326 11.0447 8.65746 9.75153 8.99103V12.1808C11.0447 12.5144 12 13.6886 12 15.0859C12 16.4833 11.0447 17.6575 9.75153 17.991V21.1808C11.0447 21.5144 12 22.6886 12 24.0859C12 25.7428 10.6569 27.0859 9 27.0859C7.34315 27.0859 6 25.7428 6 24.0859C6 22.6881 6.95607 21.5135 8.24997 21.1805V17.9914C6.95607 17.6584 6 16.4838 6 15.0859C6 13.6881 6.95607 12.5135 8.24997 12.1805V8.99142C6.95607 8.65837 6 7.48381 6 6.08594C6 4.42908 7.34315 3.08594 9 3.08594ZM9 22.5859C8.17157 22.5859 7.5 23.2575 7.5 24.0859C7.5 24.9144 8.17157 25.5859 9 25.5859C9.82843 25.5859 10.5 24.9144 10.5 24.0859C10.5 23.2575 9.82843 22.5859 9 22.5859ZM24 23.3359V24.8359H15V23.3359H24ZM9 13.5859C8.17157 13.5859 7.5 14.2575 7.5 15.0859C7.5 15.9144 8.17157 16.5859 9 16.5859C9.82843 16.5859 10.5 15.9144 10.5 15.0859C10.5 14.2575 9.82843 13.5859 9 13.5859ZM24 14.3359V15.8359H15V14.3359H24ZM9 4.58594C8.17157 4.58594 7.5 5.25751 7.5 6.08594C7.5 6.91436 8.17157 7.58594 9 7.58594C9.82843 7.58594 10.5 6.91436 10.5 6.08594C10.5 5.25751 9.82843 4.58594 9 4.58594ZM24 5.33594V6.83594H15V5.33594H24Z",
    fill: "#1B0076"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeries);
export default __webpack_public_path__ + "static/media/series.aead8bc9.svg";
export { ForwardRef as ReactComponent };